// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f576683a","667":"4c177b65","977":"27a44779"}[chunkId] + ".chunk.js";
};